class DataClassUtil {
  public static add(datasetKey: string, ...elements: HTMLElement[]) {
    elements.forEach((element: HTMLElement) => {
      if (element) {
        const className: string | undefined = element.dataset[datasetKey];
        if (className) {
          element.classList.add(className);
        }
      }
    });
  }

  public static remove(datasetKey: string, ...elements: HTMLElement[]) {
    elements.forEach((element: HTMLElement) => {
      if (element) {
        const className: string | undefined = element.dataset[datasetKey];
        if (className) {
          element.classList.remove(className);
        }
      }
    });
  }
}

export { DataClassUtil };
